import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _extends from "@babel/runtime-corejs2/helpers/extends";
var _excluded = ["variant", "theme", "title", "className"];
import clsx from 'clsx';
import * as React from 'react';
import { Base } from '../Base';
import { SrOnly } from '../Helper';
import Svg from '../Svg';
var styles = {
  "root": "Products-root_1mjWC",
  "icon": "Products-icon_2qWzn",
  "pulse": "Products-pulse_1Sm2b",
  "default": "Products-default_1RifK",
  "small": "Products-small_1j9FU"
};
var Icon = function Icon(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    className: styles.icon
  }, props));
};
function Products(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'light' : _ref$theme,
    title = _ref.title,
    className = _ref.className,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  var rootClasses = clsx(styles.root, styles[variant], className);
  var svgTheme = theme === 'dark' ? 'white' : 'green';
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement(Base, _extends({
      className: rootClasses
    }, extraProps), /*#__PURE__*/React.createElement(Icon, {
      name: "domainOutline",
      theme: svgTheme
    }), /*#__PURE__*/React.createElement(Icon, {
      name: "dnsOutline",
      theme: svgTheme
    }), /*#__PURE__*/React.createElement(Icon, {
      name: "certificatesOutline",
      theme: svgTheme
    }), /*#__PURE__*/React.createElement(Icon, {
      name: "simplehostingOutline",
      theme: svgTheme
    }), /*#__PURE__*/React.createElement(Icon, {
      name: "cloudOutline",
      theme: svgTheme
    }), /*#__PURE__*/React.createElement(SrOnly, null, title))
  );
}
export default Products;